import React, { useContext, useState } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Box, Button, Grid } from '@mui/material'
import OnboardingMultiOptionTile from 'components/OnboardingMultiOptionTile'

export function InvestorProfile({ onNext, key }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const [selectedOption, setSelectedOption] = useState(null)

  const optionArray = [
    {
      optionLabel: 'Very Conservative',
      optionValue: 'veryConservative',
    },
    {
      optionLabel: 'Conservative',
      optionValue: 'conservative',
    },
    {
      optionLabel: 'Moderate',
      optionValue: 'moderate',
    },
    {
      optionLabel: 'Aggressive',
      optionValue: 'aggressive',
    },
    {
      optionLabel: 'Very Aggressive',
      optionValue: 'veryAggressive',
    },
    {
      optionLabel: "I don't know",
      optionValue: 'iDontKnow',
    },
  ]

  const handleContinue = () => {
    if (onNext) onNext()
  }

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box mt={3}>
        <OnboardingMultiOptionTile
          id="investorProfile"
          header="How would you describe yourself as an investor?"
          subHeader="Select one of the following:"
          tileSize={{ xs: 12, sm: 6, md: 4 }}
          optionArray={optionArray}
          helpText=""
          onChange={(value) => {
            updateIntakeStateAtKey({
              riskAssessment: {
                ...intakeState?.riskAssessment,
                investorProfile: value,
              },
            })
            setSelectedOption(value)
          }}
        />
      </Box>
      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button variant="parcoRounded" onClick={handleContinue} disabled={!selectedOption}>
          Next
        </Button>
      </Box>
    </Grid>
  )
}

export default InvestorProfile
